import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { BRAND } from "@/lib/brand";

const GAMES = [
  {
    title: "Rocket League",
    division: "Division I — Aerial",
    image: BRAND.games.rocketLeague,
    blurb:
      "Triple-tap ceiling shots, gold-tier rotations. Our 3v3 squad runs the highest demo count in the circuit.",
    span: "lg:col-span-7 lg:row-span-2",
    aspect: "h-[28rem] lg:h-[36rem]",
    accent: "Top 8 Worldwide",
  },
  {
    title: "Fortnite",
    division: "Division II — Royale",
    image: BRAND.games.fortnite,
    blurb:
      "Box fights, builds, and creative chaos — our Fortnite squad focuses on making the best mini-games in the Discover hub, with original maps dropping monthly.",
    span: "lg:col-span-5",
    aspect: "h-72",
    accent: "FNCS Qualified",
  },
  {
    title: "Minecraft",
    division: "Division III — Build",
    image: BRAND.games.minecraft,
    blurb:
      "PvE strats, parkour, redstone engineering, and original studio realms — including the upcoming Goldforge map.",
    span: "lg:col-span-5",
    aspect: "h-72",
    accent: "Studio Wing",
  },
];

export default function FeaturedGames() {
  return (
    <section
      id="games"
      data-testid="featured-games-section"
      className="relative py-24 lg:py-32 bg-[#050505]"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-6 mb-14">
          <div>
            <p className="text-xs font-bold uppercase tracking-[0.3em] text-[#D4AF37]">
              ⌁ Three Thrones
            </p>
            <h2 className="mt-3 font-display text-4xl sm:text-5xl lg:text-6xl font-black uppercase tracking-tight text-white">
              Featured <span className="gold-text">Battlegrounds</span>
            </h2>
          </div>
          <p className="max-w-md text-zinc-400">
            Each title is run as its own competitive division — full-time
            coaches, dedicated analysts, and weekly scrim blocks against tier-1
            opposition.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-12 gap-5">
          {GAMES.map((g, i) => (
            <motion.div
              key={g.title}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-80px" }}
              transition={{ duration: 0.6, delay: i * 0.08 }}
              className={`tgl-card cut-corners group relative overflow-hidden ${g.span} ${g.aspect}`}
              data-testid={`game-card-${g.title.toLowerCase().replace(/\s+/g, "-")}`}
            >
              <img
                src={g.image}
                alt={g.title}
                className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-105 opacity-80"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black via-black/60 to-transparent" />
              <div className="absolute inset-0 p-6 lg:p-8 flex flex-col justify-between">
                <div className="flex justify-between items-start">
                  <span className="text-[10px] font-bold uppercase tracking-[0.3em] text-[#D4AF37] bg-black/60 border border-[#D4AF37]/30 px-3 py-1">
                    {g.division}
                  </span>
                  <ArrowUpRight
                    size={20}
                    className="text-[#D4AF37] opacity-0 group-hover:opacity-100 transition-opacity"
                  />
                </div>
                <div>
                  <span className="text-[10px] font-bold uppercase tracking-[0.3em] text-[#F3E5AB]">
                    {g.accent}
                  </span>
                  <h3 className="mt-2 font-display text-3xl lg:text-4xl font-black uppercase text-white">
                    {g.title}
                  </h3>
                  <p className="mt-3 text-sm text-zinc-300 max-w-md">
                    {g.blurb}
                  </p>
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
